import { createContext, useContext } from 'react';

import type { LinkedProject } from '../types';

type ProjectPickerContext = {
	linkedProject?: LinkedProject;
	siteIds: string[];
	analyticsAttributes?: Record<string, any>;
	hasProjectCreateAccess?: boolean;
	onCreateProject?: () => void;
	onProjectSelect?: (project: LinkedProject) => void;
	onProjectUnlink?: () => void;
};
export const ProjectPickerContext = createContext<ProjectPickerContext>({
	linkedProject: undefined,
	siteIds: [],
	analyticsAttributes: undefined,
	hasProjectCreateAccess: false,
	onCreateProject: undefined,
	onProjectSelect: undefined,
	onProjectUnlink: undefined,
});

export const useProjectPicker = () => {
	const context = useContext(ProjectPickerContext);

	return {
		linkedProject: context.linkedProject,
		siteIds: context.siteIds,
		hasProjectCreateAccess: context.hasProjectCreateAccess,
		onCreateProject: context.onCreateProject,
		onProjectSelect: context.onProjectSelect,
		onProjectUnlink: context.onProjectUnlink,
	};
};

export const useAnalyticsAttributes = () => {
	const context = useContext(ProjectPickerContext);

	return context.analyticsAttributes;
};
